import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { AlertTriangle, Lock } from 'lucide-react';

const LicenseBanner = () => {
  const { isViewOnly, licenseStatus } = useAuth();

  if (!isViewOnly) return null;

  return (
    <div className="bg-red-600 text-white px-4 py-2 shadow-md relative z-[60]">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="bg-white/20 p-1.5 rounded-full">
            <Lock className="w-4 h-4 text-white" />
          </div>
          <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-2">
            <span className="font-bold text-sm uppercase tracking-wider">View Only Mode</span>
            <span className="hidden sm:inline text-red-200">|</span>
            <span className="text-sm font-medium">
              {licenseStatus?.message || 'License is invalid or expired.'} Data entry and downloads are disabled.
            </span>
          </div>
        </div>
        <div className="hidden md:flex items-center gap-4">
           <span className="text-xs bg-red-800/50 px-2 py-1 rounded text-red-100 border border-red-700">
             Code: {licenseStatus?.code || 'INVALID_LICENSE'}
           </span>
        </div>
      </div>
    </div>
  );
};

export default LicenseBanner;
